<script setup lang="ts">
defineProps<{ dirtyCount: number; saving: boolean }>();
defineEmits<{ (e: "save"): void; (e: "discard"): void }>();
</script>

<template>
  <div
    v-if="dirtyCount > 0"
    class="sticky bottom-0 left-0 right-0 mt-4 bg-white/95 backdrop-blur ring-1 ring-slate-200 rounded-xl shadow-lg px-4 py-3 flex items-center justify-between"
  >
    <p class="text-sm text-slate-700 tabular">
      <span class="font-bold text-slate-900">{{ dirtyCount }}</span>
      unsaved change{{ dirtyCount === 1 ? '' : 's' }}
    </p>
    <div class="flex gap-2">
      <button
        type="button"
        @click="$emit('discard')"
        :disabled="saving"
        class="px-4 py-2 rounded-md text-slate-500 hover:text-slate-900"
      >Discard</button>
      <button
        type="button"
        @click="$emit('save')"
        :disabled="saving"
        class="px-5 py-2 rounded-md bg-gradient-to-b from-amber-300 to-pot1 text-amber-950 font-bold shadow-sm disabled:from-slate-200 disabled:to-slate-300 disabled:text-slate-500 disabled:shadow-none"
      >{{ saving ? "Saving…" : "Save Changes" }}</button>
    </div>
  </div>
</template>
